import { render } from "./Notifications.vue?vue&type=template&id=043a11ca&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=043a11ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043a11ca"]])

export default __exports__